export const RightArrow=()=>{
  return(
    <>
      <svg width="8" height="15" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.382399 0.382399C0.137549 0.627323 0 0.959466 0 1.30579C0 1.65211 0.137549 1.98425 0.382399 2.22918L6.84743 8.69421L0.382399 15.1592C0.144488 15.4056 0.0128435 15.7355 0.0158193 16.0779C0.018795 16.4204 0.156153 16.748 0.398309 16.9901C0.640464 17.2323 0.968042 17.3696 1.31049 17.3726C1.65294 17.3756 1.98285 17.2439 2.22918 17.006L9.6176 9.6176C9.86245 9.37268 10 9.04053 10 8.69421C10 8.34789 9.86245 8.01575 9.6176 7.77082L2.22918 0.382399C1.98425 0.137549 1.65211 0 1.30579 0C0.959466 0 0.627323 0.137549 0.382399 0.382399Z" fill="#2C3E50"/>
</svg>
    </>
  )
}